"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ready_state_exports = {};
__export(ready_state_exports, {
  isAliasAssigned: () => isAliasAssigned,
  isAliasError: () => isAliasError,
  isDone: () => isDone,
  isFailed: () => isFailed,
  isReady: () => isReady
});
module.exports = __toCommonJS(ready_state_exports);
const isReady = ({
  readyState,
  state
}) => readyState === "READY" || state === "READY";
const isFailed = ({
  readyState,
  state
}) => {
  if (readyState) {
    return readyState.endsWith("_ERROR") || readyState === "ERROR";
  }
  if (!state) {
    return false;
  }
  return state.endsWith("_ERROR") || state === "ERROR";
};
const isDone = (buildOrDeployment) => isReady(buildOrDeployment) || isFailed(buildOrDeployment);
const isAliasAssigned = (deployment) => Boolean(deployment.aliasAssigned);
const isAliasError = (deployment) => Boolean(deployment.aliasError);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAliasAssigned,
  isAliasError,
  isDone,
  isFailed,
  isReady
});
